import cn from "classnames";
import InlineBtn from "components/shared/inlineBtn";
import format from "date-fns/format";
import isToday from "date-fns/isToday";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import React, { useEffect, useRef, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { Link } from "react-router-dom";
import { getMessages, PER_PAGE, setMessagesAsRead } from "sources/assistantChat";
import Settings from "./settings";

const Assistant = (props) => {
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([]);
    const [page, setPage] = useState(0);
    const [isLastPage, setIsLastPage] = useState(false);
    const scrollContainer = useRef();

    const handleScroll = (e) => {
        if (e.target.scrollTop < 50) {
            getNextItems();
        }
    };

    const getNextItems = () => {
        if (isLastPage || loading) {
            return;
        }
        setLoading(true);
        getMessages(page).then((res) => {
            const scrollPos = scrollContainer.current.state.scrollPos;
            const prevContentHeight = scrollContainer.current.contentHeight;
            setMessages((prev) => [...res.reverse(), ...prev]);
            if (res.length < PER_PAGE) {
                setIsLastPage(true);
            }
            setPage((prev) => prev + 1);
            setTimeout(() => {
                scrollContainer.current.updateScrollPosition(
                    scrollContainer.current.contentHeight - prevContentHeight + scrollPos,
                );
                setLoading(false);
            }, 0);
        });
    };

    const refreshData = () => {
        setLoading(true);
        getNextItems();
    };

    useEffect(() => {
        setMessagesAsRead();
        refreshData();
    }, []);

    const showSettings = () => {
        props.modal({
            name: "default",
            windowMod: "wide",
            withoutHeader: true,
            CustomBody: Settings,
        });
    };

    return (
        <div className={cn("page-content", { "loader-snippet--disable-loader": loading })}>
            <div className="page-col page-col--full mounted">
                <div className={cn("page-book__list d-flex flex-column", { loading })}>
                    <div className="book-list__head">
                        <div className="book-list__head-close close close--sm" />
                        <div className="book-list__head-title">Ассистент</div>
                        <div>
                            <InlineBtn value="Настройки" cname="gear" action={showSettings} />
                        </div>
                    </div>
                    <div className="flex-grow-1 overflow-auto bg-secondary">
                        <CustomScroll
                            keepAtBottom
                            ref={scrollContainer}
                            heightRelativeToParent="100%"
                            onScroll={handleScroll}
                        >
                            <div className="a-chat">
                                {messages.map((item) => {
                                    const createdAt = new Date(item.createdAt);
                                    return (
                                        <div key={item.id} className="a-chat__item">
                                            {item.text}
                                            {item.report && (
                                                <div className="pt-2">
                                                    <Link
                                                        className="btn btn-xs btn-outline-primary"
                                                        to={`${paths.assistantChatReport(
                                                            item.report.reportType,
                                                            item.report.id,
                                                        )}?source=assistant`}
                                                        target="_blank"
                                                    >
                                                        Посмотреть отчет
                                                    </Link>
                                                </div>
                                            )}
                                            <span className="text-muted a-chat__item-time">
                                                {format(createdAt, isToday(createdAt) ? "HH:mm" : "dd.MM.yyyy HH:mm")}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </CustomScroll>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default viewContainer(Assistant);
